
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmLightOff as ObiAlarmLightOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-light-off.js';
 
 
 

 
 export const ObiAlarmLightOff = createComponent({
   react: React,
   tagName: 'obi-alarm-light-off',
   elementClass: ObiAlarmLightOffElement,
   events: {
     
   }
  });
 
 